<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.reservation && sessionConfigType">
  <app-popup-header title="{{onGetHeader()}}" [isRefresh]="true" (onRefresh)="onLoad()"></app-popup-header>
  <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="box" *ngIf="sessionConfigType == 1">
      <div>
        <app-label [Text]="localService.languageContent.reservation.session_user"></app-label>
      </div>
      <div class="row">
        <div class="col-8">
          <app-business-relationship [businessId]="businessId" (onUserUpdated)="onUserUpdated($event)"
            [relationShipType]="relationShipType" [relationShipRole]="relationShipRole"></app-business-relationship>
        </div>
        <div class="col-4">
          <input autocomplete="off" type="text" maxlength="20" [(ngModel)]="userName"
            [ngClass]="userName != '' ? 'en': ''" title="{{localService.languageContent.reservation.name}}"
            placeholder="{{localService.languageContent.reservation.name}}" />
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <app-label [Text]="localService.languageContent.reservation.queue"></app-label>
        </div>
        <div class="col-8">
          <ngx-select *ngIf="queues" [(ngModel)]="selectedQueueId" [noAutoComplete]="true" [allowClear]="true"
            [items]="queues" [optionValueField]="'key'" [optionTextField]="'v4'"
            placeholder="{{localService.languageContent.reservation.select_queue}}">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <div>
                <span
                  [ngClass]="option.data.v3 ? localService.getLanguageCode(option.data.v3) : 'en'">{{option.data.v4}}</span>
                <span class="en">&nbsp;({{option.data.v1}})</span>
              </div>
            </ng-template>
          </ngx-select>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="seatInfo">
      <div class="col-1">
        &nbsp;
      </div>
      <div class="col-11">
        <div class="en">
          <i class="material-icons delete_icon action_icon" (click)="onAction(4,seatInfo.key)">cancel</i>
          {{seatInfo.v2}}
          &nbsp;/&nbsp;
          {{seatInfo.v1}}
        </div>
        <div>
          <app-label [Text]="localService.languageContent.reservation.associated_session"></app-label>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="sessionConfigType == 2 && !isForceAttachBill">
      <div class="col-1">
        &nbsp;
      </div>
      <div class="col-11">
        <div class="en">
          <app-search-token (onSearchToken)="onAction(7,$event)" [businessId]="businessId" [isEmitOnBlur]="true"
            [isShowValidationMessage]="true"></app-search-token>
        </div>
        <div>
          <app-label [Text]="localService.languageContent.reservation.associated_session"></app-label>
        </div>
      </div>
    </div>
    <div class="box" *ngIf="seats">
      <div>
        <app-label [Text]="localService.languageContent.reservation.seats"></app-label>
      </div>
      <div class="row" *ngFor="let item of seats.groups;">
        <div class="col-3 en" style="text-align:right;">
          {{item.v1}}
        </div>
        <div class="col-9">
          <app-seat-arrangements [seatsStatusAndTitle]="onGetSeatArrangement(item.key)" [seatTypeStr]="item.v2"
            [isSelectable]="true" (onSeatsSelected)="onSeatsSelected($event,item.key)"></app-seat-arrangements>
        </div>
      </div>
    </div>
    <div *ngIf="activeSessions">
      <div *ngFor="let item of activeSessions.sessions">
        <div class="box" *ngIf="ignoreSessionIds.indexOf(item.key) == -1">
          <div class="row">
            <div class="col-4 en">
              <i *ngIf="sessionConfigType == 4 || sessionConfigType == 5" class="material-icons delete_icon action_icon"
                (click)="onAction(2,item.key)">cancel</i>
              <label *ngIf="sessionConfigType == 2" style="font-weight: normal; margin-left: 15px;">
                <input type="checkbox" [(ngModel)]="item.isSelected" (change)="onAction(5)" />
                <span class="normal_color">{{item.v1}}</span>
              </label>
              <span *ngIf="sessionConfigType != 2">{{item.v1}}</span>
            </div>
            <div class="col-5">
              <span class="en">{{item.v5 | localDate}}</span>
            </div>
            <div class="col-3" style="text-align:right;">
              <button class="button_icon button_icon_color"
                *ngIf="!isSeatsLoaded(item.key) && (sessionConfigType == 2 || sessionConfigType == 4)"
                (click)="onAction(3,item.key)">airline_seat_recline_normal</button>
              <button class="button_icon button_icon_color" *ngIf="isElligibleForBill && !isBillsLoaded(item.key)"
                (click)="onAction(8,item.key)">receipt</button>
            </div>
          </div>
          <div class="row" *ngIf="item.v4 != ''">
            <div class="col-12">
              <span [ngClass]="item.v3 ? localService.getLanguageCode(item.v3) : 'en'">{{item.v4}}</span>
            </div>
          </div>
          <div class="row" *ngFor="let itemSub of onGetSeats(item.key);">
            <div class="col-3 en" style="text-align:right;">
              {{itemSub.v1}}
            </div>
            <div class="col-9">
              <app-seat-arrangements [seatsStatusAndTitle]="onGetSeatArrangementBySessionId(item.key,itemSub.key)"
                [seatTypeStr]="itemSub.v2"></app-seat-arrangements>
            </div>
          </div>
          <div class="row" *ngFor="let itemSub of onGetBills(item.key);">
            <div class="col-6 en">
              <i class="material-icons icon_adjust" (click)="onAction(9,itemSub.key)">print</i>
              &nbsp;
              <span class="button" (click)="onAction(10,itemSub.key)">{{itemSub.value}}</span>
            </div>
            <div class="col-6" style="text-align:right;">
              <i *ngIf="sessionConfigType == 2 || sessionConfigType == 4" class="material-icons delete_icon icon_adjust"
                (click)="onDetachBill(item.key,itemSub.key)">cancel</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer" *ngIf="sessionConfigType == 1 || sessionConfigType == 2">
    <div class="row" style="width:100%;">
      <div class="col-8">
        <app-label [Text]="localService.languageContent.reservation.selected_count"></app-label>
        <span class="en">{{selectedCount}}</span>
      </div>
      <div class="col-4" style="text-align:right;">
        <button type="button" class="btn btn-primary"
          (click)="onAction(sessionConfigType == 2 ? 6 : 1)">{{sessionConfigType == 2 ?
          localService.languageContent.reservation.attach : localService.languageContent.common.create}}</button>
      </div>
    </div>
  </div>
</div>